import { ConfigCampaign } from "@forwardflow/components/Campaign/ConfigCampaign";
import { DashboardContainer } from "@forwardflow/components/Dashboard";

const ConfigCampaignPage = () => {
   return (
      <>
         <DashboardContainer>
            <ConfigCampaign />
         </DashboardContainer>
      </>
   );
};

export default ConfigCampaignPage;
